import { Capacitor } from '@capacitor/core';

/**
 * Is the app running inside a native (Capacitor) shell — iOS / Android / desktop
 * WebView — rather than a plain web browser?
 *
 * This matters for networking: a native WebView is NOT subject to browser CORS
 * rules, so it can talk to any Cashu mint directly (including mint.minibits.cash,
 * which sends no CORS headers). In a plain browser we must use a CORS-enabled
 * mint. `Capacitor.isNativePlatform()` is web-safe and simply returns `false`
 * when there's no native runtime.
 */
export function isNativePlatform(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}

/** 'ios' | 'android' | 'web' */
export function getPlatform(): string {
  try {
    return Capacitor.getPlatform();
  } catch {
    return 'web';
  }
}
